// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Copyright (c) 2025 Robert Schiwon
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

sf-dialog > dialog {
  font-family: sans-serif;
  font-size: 14px;
  width: 50%;
  padding: 0%;
}

sf-dialog > dialog .dialog-content {
  display: flex;
  flex-direction: column;
  padding: 1em;
}

sf-dialog > dialog img.sf-logo {
  height: 56px;
  padding: 0em 0.5em 0em 0.5em;
  vertical-align: middle;
}

sf-dialog > dialog button {
  float: right;
  border: 1px solid;
  border-radius: 2px;
}

sf-dialog > dialog::backdrop {
  background: rgba(0, 0, 0, 0.5);
}

sf-dialog > dialog[open] {
  animation: fadein 0.1s forwards;
}

/* this does not work, a class needs to be added manually for a closing animation */
/* https://stackoverflow.com/a/71984473 */
/* sf-dialog > dialog::not([open]) {
  animation: fadein 0.5s backwards;
} */

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media screen and (max-width: 576px) {
  sf-dialog > dialog {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/Dialog.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE;;AAEF;EACE,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mFAAmF;AACnF,yCAAyC;AACzC;;GAEG;;AAEH;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/**\n * Copyright (c) 2025 Robert Schiwon\n *\n * Permission is hereby granted, free of charge, to any person obtaining a copy of\n * this software and associated documentation files (the \"Software\"), to deal in\n * the Software without restriction, including without limitation the rights to\n * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of\n * the Software, and to permit persons to whom the Software is furnished to do so,\n * subject to the following conditions:\n *\n * The above copyright notice and this permission notice shall be included in all\n * copies or substantial portions of the Software.\n *\n * THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR\n * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS\n * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR\n * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER\n * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN\n * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.\n */\n\nsf-dialog > dialog {\n  font-family: sans-serif;\n  font-size: 14px;\n  width: 50%;\n  padding: 0%;\n}\n\nsf-dialog > dialog .dialog-content {\n  display: flex;\n  flex-direction: column;\n  padding: 1em;\n}\n\nsf-dialog > dialog img.sf-logo {\n  height: 56px;\n  padding: 0em 0.5em 0em 0.5em;\n  vertical-align: middle;\n}\n\nsf-dialog > dialog button {\n  float: right;\n  border: 1px solid;\n  border-radius: 2px;\n}\n\nsf-dialog > dialog::backdrop {\n  background: rgba(0, 0, 0, 0.5);\n}\n\nsf-dialog > dialog[open] {\n  animation: fadein 0.1s forwards;\n}\n\n/* this does not work, a class needs to be added manually for a closing animation */\n/* https://stackoverflow.com/a/71984473 */\n/* sf-dialog > dialog::not([open]) {\n  animation: fadein 0.5s backwards;\n} */\n\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  sf-dialog > dialog {\n    width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
